import { forwardRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import dayjs, { Dayjs } from "dayjs";

import { DatePickerProps } from "ui-library/atoms/Inputs/DatePicker";
import { DatePicker as NoRefDatePicker } from "ui-library/atoms";

type HookFormDatePickerProps = {
    name: string;
    disabled?: boolean;
    label?: string;
    minDate?: Dayjs;
    maxDate?: Dayjs;
    defaultCalendarMonth?: Dayjs;
    required?: boolean;
};

const DatePicker = forwardRef((props: DatePickerProps, ref) => <NoRefDatePicker {...props} />);

export default function HookFormDatePicker({ name, required, label, ...props }: HookFormDatePickerProps) {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    const error = name.split(".").reduce((acc, part) => acc?.[part], errors);

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <DatePicker
                    id={name}
                    {...field}
                    {...props}
                    label={required ? label + "*" : label}
                    value={field.value ? dayjs(field.value) : null} // convert string to dayjs for the picker
                    onChange={(newValue) => {
                        field.onChange(newValue ? newValue.format("YYYY-MM-DD") : null); // store in RHF as a string
                    }}
                    error={Boolean(error)}
                    errorContent={error?.message.toString()}
                />
            )}
        />
    );
}
